<div  class="btn btn-primary border-0 small px-2 py-0" style="border-radius: 25px"
     [appLayout]="layoutService.activeColor">
  <span style="position: relative; top:-3px">
  <i class="ri-timer-2-line " style="position: relative; top:6px"> </i>
  <a (click)="router.navigate(url.split('/'))">  <countdown  #cd [config]="timerConfig" (event)="countdownEvent($event)"></countdown></a>
    </span>
</div>
